import React from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';

import WithRouter from '../../utilities/WithRouter';
import { setCurrentCampus } from '../../actions';

import AddIcon from '../../components/icons/AddIcon';
import icon_car from '../../assets/icon_car.svg';
import icon_edit from '../../assets/icon_edit.svg';
import icon_trash from '../../assets/icon_trash.svg';
import icon_close from '../../assets/icon_close.svg';

const EVContent = ({ currentEVData, showMobile, openEVModal, powerDecisions }) => {
  function formatTime(time) {
    let newTime = time.split(' ').slice(1).join(' ');

    let hours = newTime.substring(0, newTime.indexOf(':'));
    hours = hours < 10 ? '0' + hours : hours;

    let minutes = newTime.substring(newTime.indexOf(':') + 1);

    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const ampm = hours >= 12 ? 'PM' : 'AM';

    return `${formattedHours}:${minutes} ${ampm}`;
  }

  return (
    <>
      {currentEVData && currentEVData.gridInterconnectEvChargers && (
        <>
          {currentEVData.gridInterconnectEvChargers.map((item, index) => (
            <React.Fragment key={`section-${index}`}>
              <StyledHeader>
                <h3>
                  {item.gridInterconnectShortDescription !== ''
                    ? item.gridInterconnectShortDescription
                    : item.gridInterconnectEntityKey}
                </h3>

                <div className="add-group">
                  <button
                    onClick={() => openEVModal('edit-ev', '', '', item.gridInterconnectEntityKey)}
                  >
                    <AddIcon
                      backgroundFill="#047290"
                      strokeColor="#FFFFFF"
                      strokeWidth={3}
                      width="18px"
                    />
                    Add Group
                  </button>
                </div>
              </StyledHeader>

              {item.evChargerGroups.map((group, index) => (
                <React.Fragment key={`group-${index}`}>
                  <StyledEV className="group-container">
                    <div className="group-header">
                      <h3>{group.evChargerGroupName}</h3>

                      <div className="group-edit">
                        <div
                          className="edit-button"
                          onClick={() =>
                            openEVModal(
                              'edit-ev',
                              group.evChargerGroupId,
                              '',
                              item.gridInterconnectEntityKey
                            )
                          }
                        >
                          <img
                            src={icon_edit}
                            alt="pencil and paper edit icon"
                            className="edit"
                            width="15"
                            height="15"
                          />
                        </div>
                        <div
                          className="delete-button"
                          onClick={() =>
                            openEVModal(
                              'confirm',
                              group.evChargerGroupId,
                              'delete',
                              item.gridInterconnectEntityKey
                            )
                          }
                        >
                          <img
                            src={icon_trash}
                            alt="trash can delete icon"
                            className="delete"
                            width="15"
                            height="15"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="group-contents">
                      <div className="group-devices">
                        <h4>Devices</h4>

                        <div className="group-item">
                          <table>
                            <colgroup span="2"></colgroup>
                            <tbody>
                              <tr>
                                <td rowSpan="2"></td>
                                <th className="capacity" colSpan="2" scope="colgroup">
                                  Capacity
                                </th>
                              </tr>
                              <tr>
                                <th className="subhead subcol" scope="col">
                                  Max
                                </th>
                                <th className="subhead subcol" scope="col">
                                  Current
                                </th>
                                <th className="subhead" scope="col">
                                  Measured
                                </th>
                              </tr>
                              {group.evChargers.map((charger, index) => (
                                <React.Fragment key={`charger-${index}`}>
                                  <tr>
                                    <th className="name">
                                      <img src={icon_car} alt="car icon" width="20" height="20" />
                                      {charger.shortDescription}
                                    </th>
                                    <td className="subcol">
                                      {charger.maxCapacityPowerkW.toFixed(2)} kW
                                    </td>
                                    <td className="subcol">
                                      {charger.currentCapacityPowerkW.toFixed(2)} kW
                                    </td>
                                    <td>{charger.realPowerkW.toFixed(2)} kW</td>
                                  </tr>
                                </React.Fragment>
                              ))}

                              <tr className="total">
                                <th className="total">Total</th>
                                <td className="subcol">{group.maxPowerCapacitykW.toFixed(2)} kW</td>
                                <td className="subcol">
                                  {group.currentPowerCapacitykW.toFixed(2)} kW
                                </td>
                                <td>{group.realPowerkW.toFixed(2)} kW</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="group-limit-override">
                        <div className="group-limits">
                          <h4>Limits</h4>
                          <div className="limits-container">
                            {Object.entries(powerDecisions).map(([key, value], index) => (
                              <React.Fragment key={`limit-${index}`}>
                                <div className="limit-container">
                                  <div
                                    className={
                                      group.currentPowerDecision === key ? 'limit active' : 'limit'
                                    }
                                  >
                                    <p className="limit-name">{key}</p>
                                    <p className="limit-amount">{value}%</p>
                                  </div>
                                </div>
                              </React.Fragment>
                            ))}
                          </div>
                        </div>

                        <div className="override">
                          <h4>Override</h4>
                          {group.currentPowerDecision === 'Override' ? (
                            <>
                              <div className="cancel-override">
                                <p>
                                  Active: {group.currentPowerCapacityPercent}% until{' '}
                                  {formatTime(group.overrideExpires)}
                                </p>
                                <div className="cancel-button">
                                  <button
                                    className="cancel"
                                    onClick={() =>
                                      openEVModal(
                                        'confirm',
                                        group.evChargerGroupId,
                                        'cancel-override',
                                        item.gridInterconnectEntityKey
                                      )
                                    }
                                  >
                                    Cancel Override
                                  </button>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <button
                                className="override"
                                onClick={() =>
                                  openEVModal(
                                    'override',
                                    group.evChargerGroupId,
                                    '',
                                    item.gridInterconnectEntityKey
                                  )
                                }
                              >
                                Set Override
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </StyledEV>
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </>
      )}
    </>
  );
};

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;

  h3 {
    font-weight: 600;
    margin: 0;
  }

  .add-group {
    padding-bottom: 24px;
    button {
      width: 128px;
    }
  }
`;

const StyledEV = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0px 2px 6px #02222b14;
  display: flex;
  flex-flow: column;
  margin-bottom: 24px;
  padding: 20px 24px 24px;
  row-gap: 12px;

  .group-header {
    align-items: center;
    display: flex;
    justify-content: space-between;

    h3 {
      font-size: 18px;
      margin: 0;
    }

    .group-edit {
      align-items: center;
      display: flex;
      justify-content: space-between;
      width: 38px;

      img {
        cursor: pointer;
      }
    }
  }

  .group-contents {
    display: flex;
    justify-content: space-between;

    h4 {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 12px;
    }

    .group-devices {
      border-right: 2px solid #c2d0d1;
      padding-right: 24px;
      width: 60%;

      .group-item {
        align-items: center;
        display: flex;
        justify-content: space-between;

        table {
          border-collapse: collapse;
          border-spacing: 0;
          font-size: 14px;
          text-align: left;
          width: 100%;
          th,
          td {
            border-bottom: none;
            text-align: center;
            padding: 8px 0;
          }
          th.capacity {
            background: rgba(194, 208, 209, 0.5);
            font-weight: 500;
          }
          tr th.subcol,
          tr td.subcol {
            background: rgba(194, 208, 209, 0.2);
          }

          th.subhead {
            font-style: italic;
            font-weight: 500;
          }
          th.name {
            align-items: center;
            display: flex;
          }
          th.name,
          th.total {
            text-align: left;
            // width: 180px;
            padding: 8px 16px 8px 16px;
            font-size: 12px;
            white-space: nowrap;
          }
          tr.total {
            border-top: 2px solid #edf1f2;

            td.subcol {
              background: #02222b;
              color: white;
            }
          }
          img {
            margin-right: 6px;
          }
        }
      }
    }

    .group-limit-override {
      display: flex;
      flex-flow: column;
      row-gap: 12px;
      width: 35%;

      .group-limits {
        display: flex;
        flex-flow: column;

        .limits-container {
          align-items: center;
          column-gap: 12px;
          display: flex;
          flex-flow: row wrap;
          justify-content: flex-start;
          row-gap: 12px;

          .limit {
            align-items: center;
            background: #feb02f60;
            border: 3px solid transparent;
            border-radius: 50px;
            display: flex;
            font-size: 12px;
            font-weight: 600;
            justify-content: space-between;
            opacity: 0.7;
            padding: 6px 12px;
            text-align: center;
            width: 120px;
            gap: 8px;

            p {
              margin: 0;
            }

            .limit-name {
              font-size: 11px;
              line-height: 1em;
              font-weight: 500;
            }
            .limit-amount {
              font-size: 11px;
              line-height: 1em;
              font-weight: 700;
            }

            &.active {
              background: #feb02f;
              color: #02222b;
              opacity: 1;
            }
          }
        }
      }
    }

    @media screen and (max-width: 1024px) {
      .capacity,
      .subcol {
        display: none;
      }

      .group-devices {
        width: 60%;
      }

      .group-limit-override {
        width: 35%;
      }
    }

    @media screen and (max-width: 768px) {
      flex-direction: column !important;

      h4 {
        margin: 0 0 6px;
      }
      hr {
        display: none;
      }
      .group-devices {
        border: none;
        padding-right: 0;
        margin-bottom: 24px;
        width: 100%;
      }

      .group-limit-override {
        width: 100%;
      }
    }
  }
`;

const mapStateToProps = (state) => {
  return {
    currentCampusId: state.currentCampusId,
    currentCampusData: state.currentCampusData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(EVContent));
